module.exports = __webpack_public_path__ + "static/media/alert-icon.bdaf3a8f.svg";